<template>
  <v-textarea
    :ref="textAreaRef"
    :counter="$attrs.counter"
    outlined
    :rules="[v => (v || '' ).length <= $attrs.counter || $t('sites.technicalFileDetails.noteLength')]"
    :data-cy="dataCy"
    :dense="dense"
    :autoGrow="autoGrow"
    :rows="rows"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
    props: {
        dataCy: {
            type: String,
            default: '',
        },
        dense: {
            type: Boolean,
            default: false,
        },
        autoGrow: {
            type: Boolean,
            default: false,
        },
        rows: {
            type: String,
            default: '5',
        },
    },
    data() {
        return {
            textAreaRef: this.$utils.generateRandomString(),
        };
    },
    methods: {
        async textArea() {
            return this.$utils.watchDomForMountedElement(`#${this.$attrs.id}`);
        },
        async getCursorStart() {
            return (await this.textArea()).$el.selectionStart;
        },
        async getCursorEnd() {
            return (await this.textArea()).$el.selectionEnd;
        },
        async setCursorStart(val) {
            (await this.textArea()).$el.selectionStart = val;
        },
        async setCursorEnd(val) {
            (await this.textArea()).$el.selectionEnd = val;
        },
        async setFocus() {
            (await this.textArea()).focus();
        },
    },
};
</script>
